import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReleasesComponent } from '../../releases/releases.component';
import { ReleaseDetail } from 'src/app/models/release-detail';
import { v4 as uuidv4 } from 'uuid';
import { ToastService } from '../../services/toast.service';

@Component({
    selector: 'app-edit-release-dialog',
    templateUrl: './add-description-dialog.component.html',
    styleUrls: ['./add-description-dialog.component.css'],
    standalone: false
})
export class AddDescriptionDialogComponent {
  currentIndex: number = 0;
  descriptions: ReleaseDetail[] = [];
  changeFail: boolean = false;
  newDescription: string = '';
  enableChangeFailField: boolean = false;
  descriptionToUpdate: ReleaseDetail;

  constructor(
    public dialogRef: MatDialogRef<ReleasesComponent>,
    private readonly toast: ToastService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.descriptions = data.description;
    this.changeFail = data.changeFail;
    this.enableChangeFailField = data.updateChangeFail;
    this.descriptionToUpdate = data.descriptionToUpdate;
  }

  get formattedDescription(): string {
    return this.data.description.map((d: ReleaseDetail) => d.Description).join('\n');
  }

  generateId(): string {
    return uuidv4();
  }

  addDescription(descriptionValue: string) {
    if(!this.verifyDescriptionIsNotEmpty(descriptionValue)) return;

    const newDescription = {
      Description: descriptionValue,
      DescriptionId: this.generateId()
    };

    this.descriptions.push(newDescription);
    this.data.descriptions = this.descriptions;
    this.data.closeOutEditReleaseModal = false;
    this.data.newDescription = newDescription;

    this.dialogRef.close(this.data);
  }

  verifyDescriptionIsNotEmpty(description: string): boolean {
    if (!description || description.trim().length === 0) {
      this.toast.warning('Description cannot be empty.');
      return false;
    }
    return true;
  }

  updateChangeFail(value: boolean, descriptionValue: string): void {
    if(!this.verifyDescriptionIsNotEmpty(descriptionValue)) return;

    this.changeFail = value;
    this.data.changeFail = value;

    const newDescription = {
      Description: descriptionValue,
      DescriptionId: this.generateId()
    };

    this.descriptions.push(newDescription);
    this.data.descriptions = this.descriptions;
    this.data.closeOutEditReleaseModal = false;
    this.data.newDescription = newDescription;
    this.data.changeFailUpdated = true;

    this.dialogRef.close(this.data);
  }

  updateDescription(updatedDescription: ReleaseDetail): void {
    const index = this.descriptions.findIndex(
      item => item.DescriptionId === updatedDescription.DescriptionId
    );

    if (index !== -1) {
      this.descriptions[index] = { ...this.descriptions[index], ...updatedDescription };
      this.data.descriptions = this.descriptions;
    } else {
      console.error('Object not found');
    }

    this.data.closeOutEditReleaseModal = false;
    this.data.updatedDescription = updatedDescription;

    this.dialogRef.close(this.data);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
